import { Swiper, SwiperSlide, Navigation } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import BaseImage from "../assets/images/dasboard/base.webp";
import tracknotfound from "../assets/images/track-not-found.png";

export const TrackDateFilterSection = ({
  currentMonth,
  month,
  year,
  monthlist,
  handleChange,
  setCurrentYear,
  currentYear,
}) => {
  if (currentMonth && month && year && monthlist && handleChange) {
    return (
      <div className="flex flex-row justify-center gap-2 mt-10">
        <div className="">
          <select
            className="px-5 py-3 shadow-lg rounded italic"
            defaultValue={currentMonth}
            onChange={handleChange}
          >
            {monthlist?.map((month_row, index) => {
              // Ensure you're only showing the last 3 months
              //index >= month - 3 && index < month && currentYear
              if (
                currentYear == year &&
                index <= 2 &&
                (month == 1 || month == 2)
              ) {
                return (
                  <option key={index} value={index + 1}>
                    {month_row}
                  </option>
                );
              }
              return null; // Return null if the condition is not met
            })}
          </select>
        </div>
        <div className="">
          <select
            className="px-5 py-3 shadow-lg rounded italic"
            onChange={(e) => {
              setCurrentYear(e.target.value);
            }}
          >
            {month === 1 || month === 2 ? (
              <>
                <option>{year}</option>
                <option>{year - 1}</option>
              </>
            ) : (
              <option>{year}</option>
            )}
          </select>
        </div>
      </div>
    );
  }
};

// Tabs for Day, and week
export const DayWeekTabSection = ({ dataTab, setDataTab }) => {
  return (
    <div className="w-full m-auto">
      <div className="flex flex-row justify-center gap-2 mt-10 bg-[#FFDABF] py-2 rounded-full">
        <div
          className={`cursor-pointer ${
            dataTab === "Daily"
              ? "bg-white rounded shadow-lg"
              : "bg-none rounded"
          }`}
          onClick={() => {
            setDataTab("Daily");
          }}
        >
          <div className="px-10 py-2  ">Daily</div>
        </div>
        <div
          className={`cursor-pointer ${
            dataTab === "Weekly"
              ? "bg-white rounded shadow-lg"
              : "bg-none rounded"
          }`}
          onClick={() => {
            setDataTab("Weekly");
          }}
        >
          <div className="px-10 py-2 ">Weekly</div>
        </div>
      </div>
    </div>
  );
};

// Day slide section
export const DaySlideSection = ({
  activeDayTab,
  currentWeek,
  dayOfWeek,
  setActiveDayTab,
}) => {
  return (
    <div className="flex justify-center w-full m-auto relative">
      <div className="flex flex-row justify-center gap-2 mt-5 bg-none py-2 absolute md:w-1/3 w-full z-10	">
        <Swiper
          spaceBetween={2}
          slidesPerView={7}
          initialSlide={
            activeDayTab ? parseInt(activeDayTab.slice(8, 10)) - 1 : 0
          } // Initial slide based on activeDayTab
          onSlideChange={() => {}}
          onSwiper={(swiper) => {}}
          breakpoints={{
            0: {
              slidesPerView: 3,
            },
            400: {
              slidesPerView: 3,
            },
            639: {
              slidesPerView: 4,
            },
            865: {
              slidesPerView: 4,
            },
            1000: {
              slidesPerView: 4,
            },
            1500: {
              slidesPerView: 7,
            },
            1700: {
              slidesPerView: 7,
            },
          }}
        >
          {currentWeek?.map((day_row, index) => {
            return (
              <SwiperSlide key={index}>
                <div
                  className={`${
                    dayOfWeek > index ? "cursor-pointer" : "cursor-not-allowed"
                  }  ${
                    activeDayTab === day_row.date
                      ? "bg-[#FE7701] text-white rounded shadow-lg"
                      : "bg-none rounded border border-[#ddd]"
                  }`}
                  onClick={() => {
                    if (dayOfWeek > index) {
                      setActiveDayTab(day_row.date);
                    }
                  }}
                >
                  <div className="px-2 py-2 text-center w-[50px]">
                    <small>{day_row?.dayName?.slice(0, 3)}</small>
                    <p className="font-bold">{day_row?.date?.slice(8, 10)}</p>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      <div className="desbase mb-5 bg-none z-0 -mt-[0%] relative">
        <img
          loading="lazy"
          src={BaseImage}
          alt="no-food"
          className="deshimg opacity-100 h-[180px]"
        />
      </div>
    </div>
  );
};

// Week slide section
export const WeekSlideSection = ({
  weeklist,
  activeWeekTab,
  setActiveWeekTab,
  currentWeekfind,
}) => {
  return (
    <div className="w-full m-auto relative">
      <div className="flex flex-row justify-center gap-2 mt-5 bg-none py-2 absolute w-full z-10">
        {weeklist?.map((week, index) => {
          return (
            <div
              className={`${
                currentWeekfind > index
                  ? "cursor-pointer"
                  : "cursor-not-allowed"
              } ${
                activeWeekTab === index
                  ? "bg-[#FE7701] text-white rounded shadow-lg"
                  : "bg-none rounded border border-[#ddd]"
              }`}
              onClick={() => {
                if (currentWeekfind > index) {
                  setActiveWeekTab(index);
                }
              }}
              key={index}
            >
              <div className="px-2 py-2 text-center">
                <p className="font-normal">{week}</p>
              </div>
            </div>
          );
        })}
      </div>
      <div className="desbase mb-5 bg-none z-0 -mt-[0%] relative">
        <img
          loading="lazy"
          src={BaseImage}
          alt="no-food"
          className="deshimg opacity-100 h-[180px]"
        />
      </div>
    </div>
  );
};

export const NotFound = () => {
  return (
    <div className="flex justify-center">
      <img src={tracknotfound} height={217} width={215} className="" />
    </div>
  );
};
